// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import { asyncActionSuffixes } from './constants';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from './createReducer';

type FetchState = {
  isFetching?: boolean;
  lastFetchAttempt?: Date;
  error?: any;
  response?: unknown;
  errorResponse?: any;
};
type Action = {
  type: string;
  [key: string]: any;
};
type Reducer = (state: FetchState, action?: Action) => Record<string, unknown>;
type PropReducerOptions = {
  asyncReducers?: {
    root?: Reducer;
    start?: Reducer;
    success?: Reducer;
    failure?: Reducer;
  };
  reducers?: { [key: string]: Reducer };
  initialStateProps?: FetchState;
};

export const initialFetchProps = {
  isFetching: false,
  lastFetchAttempt: null,
  error: null,
  response: null,
};

export const reduceFetchRoot = (reducer: any) => (state: any, action: any) => {
  return typeof reducer === 'function' ? reducer(state, action) : state;
};

export const reduceFetchStart = (reducer: any) => (state: any, action: any) => {
  const newState = {
    ...state,
    isFetching: true,
    error: null,
  };
  return typeof reducer === 'function' ? reducer(newState, action) : newState;
};

export const reduceFetchSuccess =
  (reducer: any) => (state: any, action: any) => {
    const newState = {
      ...state,
      isFetching: false,
      error: null,
      response: action.response,
      lastFetchAttempt: new Date(),
    };
    delete newState.errorResponse;
    return typeof reducer === 'function' ? reducer(newState, action) : newState;
  };

export const reduceFetchError = (reducer: any) => (state: any, action: any) => {
  const newState = {
    ...state,
    response: null,
    isFetching: false,
    error: action.error,
    errorResponse: action.response,
    lastFetchAttempt: new Date(),
  };
  return typeof reducer === 'function' ? reducer(newState, action) : newState;
};

export const createAsyncRequestReducer = (
  baseActionType: any,
  options: PropReducerOptions = {},
) => {
  const { reducers = {}, asyncReducers = {}, initialStateProps = {} } = options;
  const handlers = {
    [baseActionType]: reduceFetchRoot(asyncReducers.root),
    [baseActionType + asyncActionSuffixes.start]: reduceFetchStart(
      asyncReducers.start,
    ),
    [baseActionType + asyncActionSuffixes.success]: reduceFetchSuccess(
      asyncReducers.success,
    ),
    [baseActionType + asyncActionSuffixes.failure]: reduceFetchError(
      asyncReducers.failure,
    ),
    ...reducers,
  };
  return createReducer(createInitialState(initialStateProps), handlers);
};

export const createInitialState = (props = {}) => {
  return {
    ...initialFetchProps,
    ...props,
  };
};

export default {
  initialFetchProps,
  reduceFetchRoot,
  reduceFetchStart,
  reduceFetchSuccess,
  reduceFetchError,
  createAsyncRequestReducer,
  createInitialState,
};
